import React, {Component} from 'react';
import {Link, NavLink} from 'react-router-dom';
import * as FontAwesome from 'react-icons/lib/fa';
import firebase from 'firebase/app';
import 'firebase/database';
import logo from './vexpo-logo.png';
import icon from './favicon.ico';
import './navigation-bar.css';

/** @class NavigationBar
  * A component for rendering navigation options
  * in the Vexpo editor and displaying connection
  * state.
  */
export default class NavigationBar extends Component {
  /** @constructor
    * Constructs a new instance of the component.
    */
  constructor(props) {
    super(props);
    this.state = {connected: false}
    this.firebaseRef = firebase.database().ref('.info/connected');
    this.signOut = this.signOut.bind(this);
  }
  /** @componentWillMount
    * Connects the component to the firebase database
    * to report on connection state.
    */
  componentWillMount() {
    this.firebaseRef.on('value', snapshot => {
      this.setState({connected: snapshot.val()});
    });
  }
  /** @function componentWillUnmount
    * Disconnects the component from the database
    */
  componentWillUnmount() {
    this.firebaseRef.off();
  }
  /** @function signout
    * Signs the current user out of the application.
    */
  signOut() {
    firebase.auth().signOut()
  }
  /** @function render
    * Renders the component.
    */
  render() {
    var navLinks = [];
    var expoID = this.props.match.params.expoID
    var showID = this.props.match.params.showID
    var role = window.vexpo.user.role;
    if(expoID && showID){
      if(role === 'Admin') {
        navLinks.push(<NavLink to={`/expos/${expoID}`} exact={true} key="properties">Expo</NavLink>);
      }
      if(['Admin', 'Expo Editor'].includes(role)) {
        navLinks.push(<NavLink to={`/expos/${expoID}/shows/${showID}`} exact={true} key="show">Show</NavLink>);
        navLinks.push(<NavLink to={`/expos/${expoID}/shows/${showID}/showbag`} key="showbag">Showbag</NavLink>);
        navLinks.push(<NavLink to={`/expos/${expoID}/shows/${showID}/entry`} key="entry">Entry</NavLink>);
        navLinks.push(<NavLink to={`/expos/${expoID}/shows/${showID}/lobby`} key="lobby">Lobby</NavLink>);
        navLinks.push(<NavLink to={`/expos/${expoID}/shows/${showID}/halls`} key="halls">Halls</NavLink>);
        navLinks.push(<NavLink to={`/expos/${expoID}/shows/${showID}/booths`} key="booths">Booths</NavLink>);
        navLinks.push(<NavLink to={`/expos/${expoID}/shows/${showID}/gift-cards`} key="gift-cards">Giftcards</NavLink>);
      }
    }
    else if(expoID && role === 'Admin') {
      navLinks.push(<NavLink to={`/expos/${expoID}`} exact={true} key="properties">Expo</NavLink>);
    }
    return (
      <nav>
        <Link to='/' className="brand" >
          <img src={icon} width="24" height="24" alt=""/>
          &nbsp;
          <img src={logo} alt=""/>
        </Link>
        <div className="links">
          {navLinks}
        </div>
        <div className="pull-right">
          <span className="status">
            <FontAwesome.FaSignal />
            currently {this.state.connected ? 'online' : 'offline'}
          </span>
          <a onClick={this.signOut}>
            Sign Out
            <FontAwesome.FaSignOut />
          </a>
        </div>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/navigation-bar/navigation-bar.js